<template lang="pug">
  .consultation--output-category.output-globals
    template(v-if="isConcept")
      v-row(v-for="field in fields" :key="field.id")
        v-col.d-flex.pr-0(cols="6")
          field-row.flex-grow-1(
            :field="field"
            label-class="font-weight-bold"
            value-class="font-weight-bold"
            hide-value
          )
          h4.vertrag-value.mt-2 {{ getFormattedValue(field) }}

        v-col(cols="6")
          h4.col-concept-status.ml-5.mt-2.pl-1 {{ getKonceptValue(field) }}

    template(v-else)
      v-flex.xs12.lg8(v-for="field in fields" :key="field.id")
        field-row(
          :field="field"
          :label-class="`font-weight-bold`"
          :value-class="`font-weight-bold`"
        )
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator'
import FormMixin from '@/mixins/form'

@Component({
  components: {
    FieldRow: () => import('./field-row')
  },

  mixins: [
    FormMixin
  ]
})
export default class OutputGlobals extends Vue {
  @Prop({ type: Array, default: () => [] }) fields
  @Prop({ type: Array, default: () => [] }) konceptFields

  getKonceptValue (field) {
    const f = this.konceptFields.find(k => k.field_id === field.field_id)
    if (!f) {
      return ''
    }
    return this.getFormattedValue(f)
  }
}
</script>

<style lang="sass">
.output-globals
  .row + .row
    margin-top: 0px

  .vertrag-value
    flex: 0 0 85px
    white-space: nowrap
</style>
